import
  React
from 'react';

import {
  useHistory,
  useLocation
} from 'react-router';

import
  PropTypes
from 'prop-types';

import {
  VContainer,
  VFillContainer
} from '@vodacom/web-common';

import {
  ActivationStatus,
  CustomColors,
  TransactionType
} from '../../../../constants';

import {
  SecondaryButton,
  TextRow
} from 'components';

import {
  handleUtagLinkEvent,
  isEqual,
  printCurrency
} from 'helpers';

export const PurchaseCard = (props) => {

  const history = useHistory();
  const location = useLocation();

  return (

    <VFillContainer
      margin={props.margin}
      borderRadius={'4px'}
      backgroundColor={CustomColors.White}
      padding={'24px 20px'}
      boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}>

      <TextRow
        margin={'0 0 8px'}
        leftText={props.description}
        leftFontWeight={'bold'}/>

      <VContainer
        margin={'8px 0'}
        width={'100%'}
        borderBottom={`0.6px solid ${CustomColors.Grey5}`}/>

      <TextRow
        leftText={'Payment due:'}
        rightText={props.paymentDue}/>

      { isEqual(props.paymentMethod, TransactionType.Advance) &&
        <TextRow
          leftText={'Outstanding amount:'}
          rightText={printCurrency(props.outstandingAmount)}/>
      }

      <TextRow
        leftText={'Payment method:'}
        rightText={props.paymentMethod}/>

      <TextRow
        leftText={'Voucher status:'}
        rightText={
          isEqual(props.voucherStatus, ActivationStatus.Expired)
          ? `${props.voucherStatus} ${props.expiryDate}`
          : props.voucherStatus
        }
        rightFontColor={
          isEqual(props.voucherStatus, ActivationStatus.RedeemPending) ||
          isEqual(props.voucherStatus, ActivationStatus.Redeemed)
            ? CustomColors.Green5
            : undefined
        }/>

      <VContainer
        margin={'8px 0 16px'}
        width={'100%'}
        borderBottom={`0.6px solid ${CustomColors.Grey5}`}/>

      <SecondaryButton
        text={'See details'}
        onClick={() => {

          handleUtagLinkEvent({
            link_id: 'cbu: connectu: voucher advance: past purchase: see details'
          });

          history.push({
            pathname: `${location.pathname}/detail`,
            state: {
              voucherHistory: { ...props }
            }
          });
        }}/>

    </VFillContainer>
  );
};

PurchaseCard.propTypes = {
  outlet: PropTypes.string,
  paymentDue: PropTypes.string,
  outstandingAmount: PropTypes.number,
  paymentAmount: PropTypes.string,
  paymentMethod: PropTypes.string,
  voucherStatus: PropTypes.string,
  description: PropTypes.string
};